import * as React from 'react';
import { Seats } from '../../../../../../CheckoutAdditionalService/components';
import { SeatReclineExtra, SeatWindow } from '../../../../../../Icons';
import { useTheme } from '../../../../../../theme';
import cn from 'classnames';
const AggregatedSeats = ({ segmentId, service, hideCard }) => {
    const theme = useTheme('Checkout').ServicesAggregationPage;
    return (React.createElement(Seats, { aggregationMode: true, isCheckinAvailable: false, segmentId: segmentId, minPrice: service.minPrice, totalPrice: service.totalPrice, isSelected: !!service.selectedServices.length, aggregationIcons: [SeatReclineExtra, SeatWindow], className: cn({
            [theme.hideServiceCard]: hideCard
        }) }, service.selectedServices.length > 0 && (React.createElement("div", { className: theme.seatsService }, service.selectedServices.map(service => {
        return React.createElement("span", null, service.service.number);
    })))));
};
export default AggregatedSeats;
